<template>
    <div class="card text-dark mb-3" :class="className">
        <div class="card-header d-flex" v-if="header">
            <h2 class="flex-grow-1 fs-6 fw-normal">{{ header }}</h2>
            <div>
                <slot name="header"></slot>
            </div>
        </div>
        <div class="card-body">
            <h3 class="h5 card-title" v-if="title">{{ title }}</h3>
            <p class="card-text">
                <slot></slot>
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        header?: string;
        title?: string;
        variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";
    }>(),
    {}
);

const className = computed(() => {
    if (!props.variant) {
        return null;
    }
    return `bg-${props.variant}`;
});
</script>
